import Swiper from 'swiper/bundle';
import 'bootstrap/js/dist/tab';
import VideoPlayer from "../modules/VideoPlayer";
import ColorSelector from "../modules/ColorSelector";
import ReviewList from "../modules/ReviewList";
import ReviewFilter from "../modules/ReviewFilter";
import ReviewFilterImages from "../modules/ReviewFilterImages";
import ProductVariations from "../modules/ProductVariations";
import AjaxAddToCartVariation from "../modules/AjaxAddToCartVariation";
import "readmore-js";
import AjaxAddToCartSimple from "../modules/AjaxAddToCartSimple";

const {__} = wp.i18n;

export default {
  init() {
    const Player = new VideoPlayer();

    const thumbs = document.querySelector('.woocommerce-gallery-thumbs');
    const productGallery = document.querySelector('.woocommerce-product-gallery');

    let productGallerySwiper, thumbsSlider;

    // Product gallery
    if (productGallery) {

      let productGalleryArgs = {
        loop: true,
        on: {
          afterInit: () => {
            Player.setIds();
            Player.init();
          },
          slideChange: () => {
            Player.pauseAll();
          },
        },
        breakpoints: {
          992: {
            navigation: {
              nextEl: document.getElementById('product-gallery-prev'),
              prevEl: document.getElementById('product-gallery-next'),
            },
          },
        },
      };

      if (thumbs) {
        const thumbsPerView = thumbs.dataset.count || 4;
        thumbsSlider = new Swiper(thumbs, {
          loop: true,
          spaceBetween: 15,
          slidesPerView: 'auto',
          freeMode: false,
          watchSlidesProgress: true,
          centeredSlides: true,
          slideToClickedSlide: true,
          breakpoints: {
            992: {
              slidesPerView: thumbsPerView,
              spaceBetween: 20,
              centeredSlides: thumbsPerView % 2 !== 0,
            },
          },
        });

        productGalleryArgs.thumbs = {
          swiper: thumbsSlider,
        }
      }

      productGallerySwiper = new Swiper(productGallery, productGalleryArgs);
    }

    // Product Variations
    new ProductVariations({
      thumbs,
      productGallery,
      productGallerySwiper,
      thumbsSlider
    });

    //TODO: Add dropup markup to shp now dropdown

    //let shpNowDropdown = document.querySelector('.btn-shopdropdown');

    // if( shpNowDropdown ) {
    //
    //     shpNowDropdown.addEventListener('show.bs.dropdown', function (event) {
    //      console.log(event.target.nextElementSibling);
    //
    //   })
    // }

    //Also viewed products slider

    const suggestedProducts = document.querySelector('#suggested-products');

    if (suggestedProducts) {
      let cards = suggestedProducts.querySelectorAll('.product-card');
      const count = cards ? cards.length : 0;

      new Swiper(suggestedProducts, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        autoHeight: false,
        loop: false,
        centeredSlides: false,
        grabCursor: true,
        enabled: count > 1,
        on: {
          breakpoint: function (swiper, breakpointParams) {
            if (!breakpointParams.enabled) {
              swiper.$el[0].classList.add('product-slider-disabled');
            } else {
              swiper.$el[0].classList.remove('product-slider-disabled');
            }
          },
        },
        breakpoints: {
          992: {
            spaceBetween: 30,
            enabled: count > 4,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          },
          2000: {
            enabled: count > 6,
          },
        },
      })
    }

    const video = document.querySelector('video');
    if (video) {
      video.volume = 0;
    }

    const bpMd = window.matchMedia("(max-width: 768px)").matches; // 768px
    let defaultHeight = bpMd ? 86 : 96;
    let introHeight = 0;
    const readMoreWrap = document.getElementById('readMoreCollapse');
    if (readMoreWrap) {
      const fullText = readMoreWrap.textContent;
      const readMoreLoader = readMoreWrap.querySelector('.read-more-loader');
      const shortEl = readMoreWrap.querySelector('.short-description-wrapper *');
      const descriptionEl = readMoreWrap.querySelector('.description-wrapper *');
      if (shortEl || descriptionEl) {
        introHeight = shortEl ? shortEl.clientHeight : descriptionEl.clientHeight;
      }

      Object.assign(readMoreLoader.style, {
        maxHeight: 'none',
        opacity: '1',
        overflow: 'initial',
        transition: 'opacity 250ms ease-in-out 0ms',
      });

      if (fullText.length > '140') {
        $(readMoreWrap).readmore({
          speed: 75,
          collapsedHeight: introHeight < defaultHeight ? introHeight : defaultHeight,
          moreLink: `<button class="btn-default text-regent-gray text-decoration-underline mt-16" type="button">${__('View More', 'canopia')}</button>`,
          lessLink: `<button class="btn-default text-regent-gray text-decoration-underline mt-16" type="button">${__('Read less', 'canopia')}</button>`,
          afterToggle: (trigger, element, expanded) => {
            if (!expanded) { // The "Close" link was clicked
              $('html, body').animate({scrollTop: element.offset().top - 140}, {duration: 100});
            }
          },
        });
      }
    }

    // Review
    new ReviewList();
    new ReviewFilter();
    new ReviewFilterImages();

    // Variable
    new ColorSelector();
    new AjaxAddToCartVariation();

    // Add To Cart Simple Product
    new AjaxAddToCartSimple();

  }, finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
